import { env } from 'Shared/constants/env';
import { FilterType, ConfigurationResponse } from '../types';

/**
 * Build query parameters for configurations endpoint
 */
export const buildQueryParams = (
  filters: FilterType,
  page: number,
  size: number,
  sort?: string
): string => {
  const params = new URLSearchParams();

  // Add filters
  Object.entries(filters).forEach(([key, value]) => {
    if (value) {
      params.append(key, value);
    }
  });

  // Add pagination
  params.append('page', page.toString());
  params.append('size', size.toString());

  // Add sorting
  if (sort) {
    params.append('sort', sort);
  }

  return params.toString();
};

/**
 * Fetch state configurations with filters, pagination, and sorting
 */
export const fetchConfigurations = async (
  token: string,
  filters: FilterType,
  page: number,
  size: number,
  sort?: string
): Promise<ConfigurationResponse> => {
  const queryParams = buildQueryParams(filters, page, size, sort);
  const url = `${env.pmwHostname}/configurations?${queryParams}`;

  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error('Failed to fetch configurations');
  }

  return response.json();
};

/**
 * Fetch filter options from configuration API
 */
export const fetchFilterOptions = async (
  token: string,
  endpoint: string
): Promise<string[]> => {
  const url = `${env.pmwHostname}/configurations/${endpoint}`;

  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch ${endpoint}`);
  }

  return response.json();
};
